import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Macht die Seite auf dem Handy installierbar (Android verlangt dafür einen
// Service Worker) und liefert sie bei wackliger Verbindung aus dem Cache.
//
// Die Update-Meldung läuft bewusst über ein DOM-Ereignis statt über einen
// React-Zustand: Registriert wird hier, außerhalb des Komponentenbaums, und
// der UpdateBanner sitzt tief darin. Ein Ereignis erspart einen Context, den
// sonst nur diese eine Meldung bräuchte.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('mt-sw-update', { detail: registration }));
  },
});
